var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDankort = function SvgDankort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E21F28",
    d: "m26.224 11.382 3.055 3.725a5.92 5.92 0 0 0-.106-6.75zM17.562 8.04c2.281 0 4 .596 4.177 2.567l2.402-2.566h4.785A5.59 5.59 0 0 0 24.618 6h-9.183a5.61 5.61 0 0 0-4.31 2.04zM13.807 10.525l-.815 2.294h3.287c.972 0 1.266-.412 1.484-1.207.218-.794-.326-1.089-.99-1.089zM24.165 15.42l-2.54-3.29c-.47 2.242-2.006 3.29-4.892 3.29H11a5.6 5.6 0 0 0 4.435 2.197h9.178a5.62 5.62 0 0 0 4.435-2.198z"
  })));
};
export default SvgDankort;